import { graphql } from "react-relay";

export const adminPanelContainerFragments = {
  viewer: graphql`
    fragment AdminPanelContainer_viewer on Viewer {
      user {
        orgs(first: 1000000) {
          edges {
            node {
              id
              experiments
              domains
              primaryOrgCalendar
              orgOverview {
                __typename
                ... on GraphEntityError {
                  statusCode
                  message
                }
                ... on OrgOverview {
                  doNotShowOverview
                }
              }
              userPerson {
                __typename
                ... on GraphEntityError {
                  statusCode
                  message
                }
                ... on Person {
                  profile {
                    givenName
                    familyName
                    externalImageUrl
                  }
                }
              }
              featureGrid {
                __typename
                ... on FeatureGrid {
                  stateMetadata {
                    primaryBillingGroupMetadata {
                      billingGroup {
                        id
                      }
                    }
                  }
                }
                ... on GraphEntityError {
                  statusCode
                  message
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const adminPanelContainerQuery = graphql`
  query AdminPanelContainerQuery {
    viewer {
      ...AdminPanelContainer_viewer
    }
  }
`;
